/*
 * @Author: 牛字杰 niuzijie@.jtexpress
 * @Date: 2022-07-26 17:30:11
 * @LastEditors: 牛字杰 niuzijie@.jtexpress
 * @LastEditTime: 2022-07-28 18:25:42
 * @FilePath: \jmssa-vip-customers-front\src\utils\dict.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { lang } from '@/utils/filters'

export const DICT = {
  // 客户指令/回复类型
  clientInstructList: [
    { label: lang('待确认'), value: 3 },
    { label: lang('退回'), value: 1 },
    { label: lang('预约派送'), value: 2 },
  ],
  // 产品类型
  expressType: [
    { value: 'EZKSA', label: 'STANDARD' },
    { value: 'Reverse', label: 'Reverse' },
    { value: 'EZ', label: 'STANDARD' },
    { value: 'ReverseUAE', label: 'Reverse' },
    { value: 'EZKW', label: 'Standard' },
    { value: 'ReverseKW', label: 'Reverse' },
    { value: 'EZQAT', label: 'Standard' },
    { value: 'ReverseQAT', label: 'Reverse' },
    { value: 'EZBHR', label: 'Standard' },
    { value: 'ReverseBHR', label: 'Reverse' },
    { value: 'EZJOR', label: 'Standard' },
    { value: 'ReverseJOR', label: 'Reverse' },
    { value: 'EZOMN', label: 'Standard' },
    { value: 'ReverseOMN', label: 'Reverse' },
  ]
}
